<script>
    import { layoutOption, newOrderId, apiConfig, mode, memberInfo, queryStr, cipherText } from '../store/inapp-store'
    import { inappFetch } from '../store/inapp-auth'
    import { Modal, Loader } from '../components';
    import { onMount } from 'svelte';
    import { onlinePaymentOpw } from '../store/openpoint' 

    $layoutOption.showBanner = false
    $layoutOption.showCarousel = false

    let payResult = {
        status: '',
        message: '',
        data: ''
    } 

    let modal = { 
        title : '登記借杯',
        message : '交易取消',
        type: 'alert'
    }

    let isOpen = false
    let loader = { content : '線上支付準備中...' } 
    let isBlock = true

    onMount(() =>{
        if($mode === 'app') {
            try {
                startOnlinePayment()
            }catch(e) {
                modal.message  = e.msg
                isBlock = false
                isOpen = true
            }

            let timer
            if(document.getElementById('payData') !== null) {
                timer = setInterval(function(){
                    var payData = document.getElementById('payData').value;
                    payResult.data = payData
                    console.log('payData', payData)
                    if(payData !== '') {
                        clearInterval(timer)

                        // 解析回傳結果，並判斷是否交易成功
                        parsePaymentResult(payData)
                        
                    }
                },1000)
            }
        } else {
            loader.content = '模擬OP錢包交易成功情境...' 
            isBlock = true
            setTimeout(doMockOnlinePayment, 1000)
        } 
    })

    /**
     * 開啟線上支付流程
     */
    function startOnlinePayment() {
        // 取得線上支付所需參數
        inappFetch(`${$apiConfig.apiUrl}/payment/data?code=${$apiConfig.apiKey}&id=${$newOrderId}&gid=${$memberInfo.gid}&payType=newopw&ct=${encodeURIComponent($cipherText)}`, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(d => {
                console.log(d)                    
                loader.content = ''
                if(d.returnCode === '0000') {
                    // 呼叫JS線上支付介面
                    onlinePaymentOpw(d.info.source, d.info.data)
                } else {
                    isOpen = true
                }
            })
    }

    /**
     * 模擬線上支付交易成功
     */
    function doMockOnlinePayment() {
        fetch(`${$apiConfig.apiUrl}/mock/payment?code=${$apiConfig.apiKey}`, {
            method: 'POST',
            body:JSON.stringify({id : $newOrderId })
        })
        .then(response => response.json())
        .then(d => {
            console.log(d)
            nextStep()
        });
    }

    /**
     * 解析 payData 電文並呼叫 payment/result API
     */
    function parsePaymentResult(payData) {
        loader.content = '處理支付結果中...'
        isBlock = true
        
        fetch(`${$apiConfig.apiUrl}/payment/result?code=${$apiConfig.apiKey}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: $newOrderId,
                result: payData
            })
        })
        .then(response => response.json())
        .then(d => {
            console.log('Payment result:', d)
            loader.content = ''
            isBlock = false
            if(d.returnCode === '0000') {
                payResult.status = d.info.payment_status
                payResult.message = d.info.opw_status_message

                // 線上支付回傳交易結果
                // Y:交易授權成功(平台端需向聚合平台詢問結果) 
                // N:交易授權錯誤(平台端需向聚合平台詢問結果) 
                // C:交易取消 (使用者自行點選流程中畫面上左上的"X")
                // T:交易授權逾時(timeout)(平台端需向聚合平台詢問結果) 
                // OF:向OPW取得預約訂單失敗
                // M:OPW系統維護
                if(payResult.status === 'Y') { 
                    var payData = document.getElementById('payData').value;
                    payResult.data = payData
                    nextStep()
                    return false
                } else {
                    if(payResult.status === 'C')  {
                        modal.message  = '交易取消'
                    } else if(payResult.status === 'N') {
                        modal.message  = '交易授權錯誤'
                    } else if(payResult.status === 'T') {
                        modal.message  = '交易授權逾時，請先查詢紀錄查詢，以確認是否訂單成立，或是稍後進行重試'
                    } else if(payResult.status === 'OF') {
                        modal.message  = '取得OPW預約訂單失敗，請稍後再試'
                    } else if(payResult.status === 'M') {
                        modal.message  = 'OPW系統維護，請稍後再試'
                    } else {
                        modal.message  = '發生錯誤，請先查詢紀錄查詢，以確認是否訂單成立，或是稍後進行重試'
                    }
                    isBlock = false
                    isOpen = true
                }
            } else {
                // 交易失敗，顯示錯誤訊息
                modal.message = '發生錯誤，請先查詢紀錄查詢，以確認是否訂單成立，或是稍後進行重試'
                isOpen = true
            }
        })
        .catch(error => {
            console.error('Payment result error:', error)
            loader.content = ''
            isBlock = false
            modal.message  = '發生錯誤，請先查詢紀錄查詢，以確認是否訂單成立，或是稍後進行重試'
            isOpen = true
        })
    }

    /**
     * 前往交易完成頁
     */
    function nextStep() {
        location.href = 'register-result'
    }

</script>

<!-- 新OPEN錢包線上支付回傳結果 -->
<input type="hidden" id="payData" >
<input type="hidden" id="payStatus" >

<Modal {modal} {isOpen} on:closeModal={e => location.href = `/home${$queryStr}` }></Modal>
<Loader {loader} {isBlock}></Loader>
